module.exports = __webpack_public_path__ + "static/loading_marisa-1.0.0.gif";